import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../styles/comercial.css';

export default function CommercialActionButton({ label, icon, onClick }) {
    const id = React.useId();
    return <OverlayTrigger placement="top" overlay={<Tooltip id={id}>{label}</Tooltip>}>
        <Button type="button" variant="light" className="commercial-icon-action" aria-label={label} onClick={onClick}>
            <FontAwesomeIcon icon={icon} aria-hidden="true" />
        </Button>
    </OverlayTrigger>;
}
